import { useCallback } from 'react';

import { useEventListener } from 'usehooks-ts';

import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Button } from '@shared/ui/Button';
import { Input } from '@shared/ui/Input';

import { changeCode, sendVerifyCode } from '../../../model/slice/authSlice';
import { ErrorText } from '../ErrorText/ErrorText';
import { Wrap } from '../Wrap/Wrap';
import { Timer } from './Timer/Timer';
import cls from './VerificationCode.module.scss';

export const VerificationCode = () => {
  const dispatch = useAppDispatch();
  const code = useAppSelector((state) => state.auth.verifyCode.code);
  const isLoading = useAppSelector((state) => state.auth.isLoading);
  const errorCode = useAppSelector((state) => state.auth.verifyCode.error);
  const errorText = useAppSelector((state) => state.auth.errorText);

  const verification = useCallback(() => {
    dispatch(sendVerifyCode());
  }, [dispatch]);

  const changeCodeHandler = useCallback(
    (value: string) => {
      dispatch(changeCode(value));

      if (value.toString().length === 6) {
        verification();
      }
    },
    [dispatch, verification]
  );

  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      if (code) {
        verification();
      }
    }
  };

  useEventListener('keydown', onKeyDown);

  return (
    <Wrap
      back
      title={'Введите проверочный смс код'}
    >
      <div
        data-testid={'verifications'}
        className={cls.wrap}
      >
        <Input
          testId={'verifications-code-input'}
          value={code}
          onChange={changeCodeHandler}
          className={cls.input}
          label={'Введите код'}
          isError={errorCode !== ''}
          errorText={errorCode}
        />

        {errorText !== '' && (
          <ErrorText
            className={cls.errorText}
            text={errorText}
          />
        )}

        <Button
          testId={'verifications-send-button'}
          disabled={code === ''}
          fullWidth
          size={'l'}
          loadingButton
          isLoading={isLoading}
          className={cls.button}
          onClick={verification}
        >
          Подтвердить код
        </Button>
        <Timer />
      </div>
    </Wrap>
  );
};
